export interface IWeeklyHygieneManagement {
  id?: string // == weekId (例: "2026-W05")
  year: string // ISO週年（週が年をまたぐ場合は calendar year と異なることがある）
  weekOfYear: number // 1-53
  weekStartDate: string // YYYY-MM-DD（月曜）
  weekEndDate: string // YYYY-MM-DD（日曜）
  manager?: string
  supervisor?: string
  ceilingChecks?: Record<string, string>
  doorChecks?: Record<string, string>
  equipmentMaintenanceChecks?: Record<string, string>
  storageChecks?: Record<string, string>
  verifier?: string
  remarks?: string
  createdAt?: string
  updatedAt?: string
}

export const formatWeekRangeLabel = (weekStartDate: string, weekEndDate: string): string => {
  const shorten = (d: string) => d.slice(5).replace("-", "/")
  return `${shorten(weekStartDate)}〜${shorten(weekEndDate)}`
}
